import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

export default function RobotsManagement() {
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    ApiRequest("GET", ApiEndpoints.robots.view)
      .then((response) => setContent(response?.robots?.content || ""))
      .catch((error) => toast.error(error.response?.data?.message || "Unable to load robots.txt file."))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrors([]);

    if (!content.trim()) {
      setErrors(["Robots.txt content is required."]);
      return;
    }

    setSaving(true);
    try {
      const response = await ApiRequest("POST", ApiEndpoints.robots.update, { content });
      toast.success(response.message);
    } catch (error) {
      const message = error.response?.data?.message || "Unable to update robots.txt file.";
      setErrors([message]);
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  const pagename = { name: "Robots.txt Management", user: "Admin", innerpage: "Robots.txt Management" };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add"><label>Robots.txt Content<small>*</small></label></div>
                  <textarea
                    name="content"
                    value={content}
                    onChange={(event) => setContent(event.target.value)}
                    className="form-control"
                    rows="28"
                    disabled={loading || saving}
                    placeholder={loading ? "Loading robots.txt file..." : "Enter the content for /robots.txt."}
                    spellCheck="false"
                    style={{ height: "auto", fontFamily: "monospace", whiteSpace: "pre", overflow: "auto" }}
                  />
                </div>
              </div>
              {errors.length > 0 && (
                <div className="col-lg-12"><div className="alert alert-danger">
                  {errors.map((error) => <div key={error}>{error}</div>)}
                </div></div>
              )}
              <div className="col-lg-12">
                <button className="default-btn" type="submit" disabled={loading || saving}>
                  {saving ? "Saving..." : "Save Robots.txt File"}<span></span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
